import React from "react";

import SalesSummaryDatarow from "./SalesSummaryDatarow";
import { formatCurrency } from "../../utility";
import { salesSummaryConstants } from "../../../constants";

const SalesSummaryDataTable = ({ atAGlance }) => {
  return (
    <>
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Sales"
        value={""}
        className="mt-3"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Gross Sales"
        value={`${formatCurrency(atAGlance?.grossSales || 0)}`}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Returns"
        value={formatCurrency(atAGlance?.totalReturns || 0)}
        className=""
        fontClassName="sales-summary-detail-heading"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Discounts"
        value={formatCurrency(atAGlance?.totalDiscounts || 0)}
        className=""
        fontClassName="sales-summary-detail-heading"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Net Sales"
        value={formatCurrency(atAGlance?.netSales || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Taxes"
        value={formatCurrency(atAGlance?.totalTaxes || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Tax Liability"
        value={formatCurrency(atAGlance?.totalSalesTax || 0)}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Gift Card Sales"
        value={formatCurrency(atAGlance?.giftCardSales || 0)}
        className=""
        fontClassName="sales-summary-detail-heading"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Store Credit Payments"
        value={formatCurrency(atAGlance?.totalStorecreditPayments || 0)}
        className=""
        fontClassName="sales-summary-detail-heading"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Total Sales"
        value={formatCurrency(atAGlance?.totalSalesAfterReturn || 0)}
        className=""
      />{" "}
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Total Sales Transactions"
        value={atAGlance?.totalSaleTransactions || 0}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Average Order Value"
        value={formatCurrency(atAGlance?.averageOrderValue || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Total COGS"
        value={formatCurrency(atAGlance?.totalCogs || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Total Profit"
        value={formatCurrency(atAGlance?.totalProfit || 0)}
        className="pb-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Trade-Ins"
        value={``}
        className="mt-5"
      />{" "}
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Total Trade Transactions"
        value={atAGlance?.totalTradeTransactions || 0}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Total Trade-In Stock Price"
        value={formatCurrency(atAGlance?.totalTradeInStockPrice || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Total Trade-In Purchases"
        value={formatCurrency(atAGlance?.totalTradeInPurchases || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Total Store Credit Payments"
        value={formatCurrency(atAGlance?.totalTradeStorecreditPayments || 0)}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Total Cash Payments"
        value={formatCurrency(
          atAGlance?.totalTradeCashPayments -
            atAGlance?.totalTradeOtherPayments || 0
        )}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Total Other Payments"
        value={formatCurrency(atAGlance?.totalTradeOtherPayments || 0)}
        className="pb-4"
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Payments"
        value={``}
        className="mt-5"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Total Collected"
        value={formatCurrency(atAGlance?.totalPayments || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Cash"
        value={formatCurrency(atAGlance?.totalCashPayments || 0)}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Credit/Debit Card"
        value={formatCurrency(atAGlance?.totalCreditCardPayments || 0)}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Gift Card"
        value={formatCurrency(atAGlance?.totalGiftcardPayments || 0)}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Store Credit"
        value={formatCurrency(atAGlance?.totalStorecreditPayments || 0)}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Other"
        value={formatCurrency(atAGlance?.totalOtherPayments || 0)}
        className=""
        fontClassName="sales-summary-detail-heading ms-4"
      />{" "}
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_1}
        title="Fees"
        value={formatCurrency(atAGlance?.fees || 0)}
        className=""
      />
      <SalesSummaryDatarow
        dataRowType={salesSummaryConstants.ROW_TYPE_3}
        title="Net Total"
        value={`${formatCurrency(atAGlance?.netTotal || 0)}`}
        className=""
      />
    </>
  );
};

export default SalesSummaryDataTable;
